import { PaginationInterface } from '../../../interfaces/general/pagination/pagination-interface';

export class PaginationModel implements PaginationInterface {
  currentPage: number = -1;
  page: number = -1;
  pageSize: number = -1;
  totalPages: number = -1;
  totalResults: number = -1;

  constructor(init?: Partial<PaginationModel>) {
    Object.assign(this, init);
  }
}
